<template>
  <v-card-text class="py-3">
    <div v-if="temperatureTemp" class="d-flex align-center justify-center mb-5">
      <div>修正前：</div>
      <v-chip color="temperature" class="mr-2" variant="outlined" size="x-small">体温</v-chip>
      <div class="">{{ formatTime(temperatureTemp.recordedAt) }}</div>
      <div class="ml-4">{{ temperatureTemp.temperature }}℃</div>
    </div>
    <div class="d-flex align-center justify-center mb-5">
      <div>平均体温：</div>
      <div class="">{{ avarageTemperature }}</div>
    </div>
    <!--
    <v-menu
      ref="temperatureRecordetAtPicker"
      v-model="isRecordetAtPicker"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="recordedAt"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="recordedAt"
          label="時間"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          readonly
          v-bind="attrs"
          v-on="on"
          outlined
          dense
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="isRecordetAtPicker"
        v-model="recordedAt"
        @change="changeRecordedAt"
        full-width
        locale="ja"
        :allowed-minutes="allowedStep"
        @click:minute="$refs.temperatureRecordetAtPicker.save(recordedAt)"
      ></v-time-picker>
    </v-menu>
    -->
    <v-menu
      v-model="isRecordetAtPicker"
      :close-on-content-click="false"
      location="bottom start"
      transition="scale-transition"
      min-width="290px"
      max-width="290px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="localRecordedAt"
          label="時間"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          color="primary"
        ></v-text-field>
      </template>

      <v-time-picker
        v-if="isRecordetAtPicker"
        v-model="localRecordedAt"
        format="24hr"
        locale="ja"
        :allowed-minutes="allowedStep"
        @update:model-value="onTimePicked"
        color="primary"
        @keydown.capture.prevent
      ></v-time-picker>
    </v-menu>

    <div class="d-flex align-baseline">
      <!-- <v-text-field
        v-model="temperature"
        @change="changeTemperature"
        :rules="[rules.required]"
        label="体温"
        type="number"
        min="0"
        outlined
        dense
      /> -->
      <v-select
        :model-value="temperature"
        @update:model-value="onChangeTemperature"
        :items="options"
        item-title="text"
        item-value="value"
        :rules="[rules.required]"
        label="体温"
        :menu-props="{ auto: true }"
        variant="outlined"
        density="compact"
      ></v-select>
      <p class="ml-1 body-1">℃</p>
    </div>
  </v-card-text>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';
import { ChildInfoResponse, ChildResponse, NurseryTemperatureResponse } from 'chaild-api/lib';
import { childrenModule } from '@/store/dataModules/childrenModule';

// model
// import { VForm } from '@/model/vuetify/VForm';

export default defineComponent({
  name: 'TemperaturteModal',

  emits: ['update:recordedAt', 'update:temperature'],

  props: {
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
    temperatureTemp: {
      type: Object as PropType<NurseryTemperatureResponse>,
    },
    inputChild: {
      type: Object as PropType<ChildResponse>
    },
    recordedAt: {
      type: String,
      default: '',
    },
    temperature: {
      type: Number,
      default: NaN
    }
  },

  computed: {
    rules() {
      return rules;
    },
    form() {
      return (this.$refs as any).post_defecation_form;
    },
    options() {
      const options: Array<{ text: string; value: number }> = [];
      for (let i = 350; i < 400; i++) {
        options.push({
          text: `${(i / 10).toFixed(1)}℃`,
          value: Number((i / 10).toFixed(1)),
        });
      }
      return options;
    },
    avarageTemperature() {
      let avarageTemperature = `-` as any
      const healthInfo = childrenModule.childInfo?.healthInfo
      if (healthInfo) {
        healthInfo.map(info => {
          if(info.key === "averageBodyTemperature") {
            avarageTemperature =  info.value as number
          }
        })
      }
      return avarageTemperature
    }
  },

  data() {
    return {
      // recordedAt: '',
      // temperature: NaN, 
      btnLoading: false,
      isRecordetAtPicker: false,
      // propsの値を直接変更しないために、ローカルなデータ変数を用意します。
      // 初期値として props.recordedAt をコピーします。
      localRecordedAt: this?.recordedAt || '',
      localTemperature: this?.temperature || '',
    }
  },

  methods: {
    allowedStep: (m: any) => m % 5 === 0,
    // 【新規】タイムピッカーで時間が選択されたときの処理
    onTimePicked(newTime: string) {
      // ローカル変数を更新（v-modelで自動更新されますが一応明示）
      this.localRecordedAt = newTime;
      const [hour, minute] = newTime.split(':');
      const iso = dayjs().hour(Number(hour)).minute(Number(minute)).second(0).millisecond(0).toISOString();
      // 親に通知して、親側のデータを更新してもらう
      this.$emit('update:recordedAt', iso);
      // メニューを閉じる
      this.isRecordetAtPicker = false;
    },
    onChangeTemperature(newTemperature: string) {
      // ローカル変数を更新（v-modelで自動更新されますが一応明示）
      this.localTemperature = newTemperature;
      // 親に通知して、親側のデータを更新してもらう
      this.$emit('update:temperature', newTemperature);
    },
    //changeRecordedAt() {
    //  this.$emit('changeRecordedAt', this.recordedAt);
    //},
    //changeTemperature() {
    //  this.$emit('changeTemperature', this.temperature);
    //},
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
  },

  //watch: {
    // 親側で recordedAt が変更された場合、ローカル変数も同期させる
  //  recordedAt(newVal) {
  //    this.localRecordedAt = newVal;
  //  },
  //},

  mounted() {
    // this.temperature = 365 / 10
    this.$emit('update:temperature', this.temperature);
    if (this.inputChild) {
      childrenModule.getChildInfo(this.inputChild.childId)
    }
  },

  watch: {
    recordedAt(newVal) {
      if (newVal) {
        this.localRecordedAt = dayjs(newVal).format('HH:mm');
      } else {
        this.localRecordedAt = '';
      }
    },
  }
});
</script>
<style lang="scss" scoped></style>
